// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"152":"a1485c1202490684","364":"3e905bdd5a20c8b4","681":"84985bb9acaaaaee"}[chunkId] + ".js";
};